//
// NOTE THAT you can't just use this class outside it's context in the App.
// This is because setProcessOrgProxyFn() and setWebsiteBehaviors() must be called before most of this is useful.
//

class Page {

	//
	// PUBLIC
	//

	constructor() {
		(this as any).pageDataOverride = null;

		(this as any).processOrgProxy = null;
		(this as any).websiteBehaviors = null;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'fn' implicitly has an 'any' type.
	setProcessOrgProxyFn(fn) {
		(this as any).processOrgProxy = fn;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'wb' implicitly has an 'any' type.
	setWebsiteBehaviors(wb) {
		(this as any).websiteBehaviors = wb;
	}

	/**
	 * Returns the page title.
	 * It uses alternative strategies if title not found.
	 *
	 * @return  string
	 */
	getPageTitle() {
		const titleElmnt = document.querySelector("head > title");
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const title = titleElmnt ? titleElmnt.textContent.trim() : null;
		if (title)
			return title;

		// Find the first h1 on the page
		const h1Elmnt = document.querySelector("h1");
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		const h1 = h1Elmnt ? h1Elmnt.textContent.trim() : null;
		if (h1)
			return h1;

		// If nothing worked, return the URL.
		return this.getPageUrl();
	}

	/**
	 * Returns the current page URL.
	 *
	 * @return  string
	 */
	getPageUrl() {
		if ((this as any).pageDataOverride)
			return (this as any).pageDataOverride.pageUrl;

		if (!(this as any).websiteBehaviors || !(this as any).processOrgProxy)
			throw new Error("Must initialize Page class properly before calling page.getPageUrl()");

		return (this as any).websiteBehaviors.getPageUrl((this as any).processOrgProxy);
	}

	/**
	 * Returns the current "clean" page URL. For example, if the regular URL is http://example-com.proxy.edu/article/1,
	 * the clean URL will probably look like http://example.com/article/1.
	 *
	 * @return  string
	 */
	getCleanUrl() {
		if ((this as any).pageDataOverride)
			return (this as any).pageDataOverride.cleanUrl;

		if (!(this as any).websiteBehaviors || !(this as any).processOrgProxy)
			throw new Error("Must initialize Page class properly before calling page.getCleanUrl()");

		// Run the `this.processOrgProxy` callback in "toPublicUrl = true" mode.
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		return (this as any).websiteBehaviors.getPageUrl((url, toPublicUrl = true) => (this as any).processOrgProxy(url, toPublicUrl), true);
	}

	getPageData() {
		if ((this as any).pageDataOverride)
			return (this as any).pageDataOverride;

		const data = {
			pageUrl:   this.getPageUrl(),
			pageTitle: this.getPageTitle()
		};

		const cleanUrl = this.getCleanUrl();
		if (cleanUrl && cleanUrl !== data.pageUrl)
			(data as any).cleanUrl = cleanUrl;

		return data;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'data' implicitly has an 'any' type.
	setPageDataOverride(data) {
		if (!(this as any).websiteBehaviors || !(this as any).processOrgProxy)
			throw new Error("Must initialize Page class properly before calling page.setPageDataOverride()");

		if (!data.cleanUrl && data.pageUrl) {
			const cleanUrl = (this as any).processOrgProxy(data.pageUrl, true);
			if (cleanUrl && cleanUrl !== data.pageUrl)
				data.cleanUrl = cleanUrl;
		}

		(this as any).pageDataOverride = data;
	}

	//
	// PRIVATE
	//

}

export default Page;
